import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ReportDashboardPage from "./ReportDashboardPage";
import ReportTopItemsPage from "./ReportTopItemsPage";
import ReportTopCustomersPage from "./ReportTopCustomersPage";
import ReportTopSuppliersPage from "./ReportTopSuppliersPage";
import ReportYearlySalesChartPage from "./ReportYearlySalesChartPage";
import ReportDailySummaryPage from "./ReportDailySummaryPage";
import ProfitReportPage from "./ProfitReportPage";
import { ReportProvider } from "../../store/reportContext";
import ReportStockReportPage from "./ReportStockReportPage";
import ProductStockValueReportPage from "./ProductStockValueReportPage";
import ItemReportPage from "./ItemReportPage";
import BestSellingReportPage from "./BestSellingReportPage";
import MostReturnedReportPage from "./MostReturnedReportPage";
import ProtectedRoute from "../../routes/ProtectedRoute";
import { ProductProvider } from "../../store/productContext";
import { PERMS } from "../../constants/permissions";

const ReportIndex: React.FC = () => (
    <ReportProvider>
        <Routes>
            <Route path="dashboard" element={<ProtectedRoute permission={PERMS.report.dashboard}><ReportDashboardPage /></ProtectedRoute>} />
            {/* The item report searches the product list, so it needs the product context. */}
            <Route
                path="item-report"
                element={
                    <ProtectedRoute permission={PERMS.report.itemReport}>
                        <ProductProvider>
                            <ItemReportPage />
                        </ProductProvider>
                    </ProtectedRoute>
                }
            />
            <Route path="best-selling" element={<ProtectedRoute permission={PERMS.report.bestSelling}><BestSellingReportPage /></ProtectedRoute>} />
            <Route path="most-returned" element={<ProtectedRoute permission={PERMS.report.mostReturned}><MostReturnedReportPage /></ProtectedRoute>} />
            <Route path="top-items" element={<ProtectedRoute permission={PERMS.report.topItems}><ReportTopItemsPage /></ProtectedRoute>} />
            <Route path="top-customers" element={<ProtectedRoute permission={PERMS.report.topCustomers}><ReportTopCustomersPage /></ProtectedRoute>} />
            <Route path="top-suppliers" element={<ProtectedRoute permission={PERMS.report.topSuppliers}><ReportTopSuppliersPage /></ProtectedRoute>} />
            <Route path="yearly-sales" element={<ProtectedRoute permission={PERMS.report.yearlySales}><ReportYearlySalesChartPage /></ProtectedRoute>} />
            <Route path="daily-summary" element={<ProtectedRoute permission={PERMS.report.dailySummary}><ReportDailySummaryPage /></ProtectedRoute>} />
            <Route path="stock-report" element={<ProtectedRoute permission={PERMS.report.stockReport}><ReportStockReportPage /></ProtectedRoute>} />
            <Route path="product-stock-value" element={<ProtectedRoute permission={PERMS.report.stockValueReport}><ProductStockValueReportPage /></ProtectedRoute>} />
            <Route path="profit-report" element={<ProtectedRoute permission={PERMS.report.profitReport}><ProfitReportPage /></ProtectedRoute>} />
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="*" element={<Navigate to="dashboard" />} />
        </Routes>
    </ReportProvider>
);

export default ReportIndex;
